<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button
          style="margin-bottom: 20px"
          type="primary"
          @click="setsu('null')"
          v-if="hasAuth('sys:auction:add')"
          >添加</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="商品名"
        align="center"
        prop="name"
        min-width="200"
      />
      <el-table-column
        label="规格名"
        align="center"
        prop="commoditSpecifications"
        min-width="200"
      />
      <el-table-column
        label="成交状态"
        align="center"
        prop="成交状态"
        width="120"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.transactionStatus == 1" type="success"
            >已成交</el-tag
          >
          <el-tag v-else-if="row.transactionStatus == 2" type="danger"
            >已流拍</el-tag
          >
          <el-tag v-else type="warning">拍卖中</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="起拍价"
        align="center"
        prop="startingPrice"
        width="120"
      />
      <el-table-column
        label="保证金"
        align="center"
        prop="auctionDeposit"
        width="120"
      />
      <el-table-column
        label="最低成交价"
        align="center"
        prop="minimumTransactionPrice"
        width="120"
      />
      <el-table-column
        label="拍卖数量"
        align="center"
        prop="auctionQuantity"
        width="120"
      />
      <el-table-column
        label="加价幅度（元）/次"
        align="center"
        prop="marginOfMarkup"
        width="140"
      />
      <el-table-column label="出价次数" align="center" prop="num" width="120">
        <template slot-scope="{ row }">
          <span style="color: green; cursor: pointer" @click="seenum(row)">{{
            row.num
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="拍卖结束时间"
        align="center"
        prop="auctionEndTime"
        width="160"
      />

      <el-table-column label="状态" align="center" width="200">
        <template slot-scope="{ row }">
          <el-tag v-if="row.auctionStatus == 1" type="success">已上架</el-tag>
          <el-tag v-if="row.auctionStatus == 0" type="danger">未上架</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="创建时间"
        align="center"
        prop="createTime"
        width="160"
      />
      <el-table-column
        label="操作"
        align="center"
        prop="icon"
        fixed="right"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="UpdateButton(scope.row)"
            v-if="scope.row.auctionStatus == 0 && hasAuth('sys:auction:edit')"
            >编辑</el-button
          >
          <el-button
            v-if="
              scope.row.auctionStatus == 0 && hasAuth('sys:auction:shangjia')
            "
            plain
            type="primary"
            @click="updState(scope.row)"
          >
            上架</el-button
          >
          <el-button
            v-if="
              scope.row.auctionStatus == 1 &&
              scope.row.transactionStatus != 1 &&
              hasAuth('sys:auction:xiajia')
            "
            plain
            type="danger"
            @click="updState(scope.row)"
          >
            下架</el-button
          >

          <el-button
            type="danger"
            plain
            slot="reference"
            v-if="scope.row.auctionStatus == 0 && hasAuth('sys:auction:del')"
            @click="delHandle(scope.row.auctionGoodsId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-dialog
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="160px"
        class="demo-editForm"
        :rules="rules"
      >
        <el-form-item label="商品" prop="commodityId">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.commoditName" disabled> </el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="selectUser"
                style="height: 40px; width: 100%"
                >选择</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="起拍价" prop="startingPrice">
          <el-input v-model="editForm.startingPrice" type="number"></el-input>
        </el-form-item>
        <el-form-item label="保证金" prop="auctionDeposit">
          <el-input v-model="editForm.auctionDeposit" type="number"></el-input>
        </el-form-item>
        <el-form-item label="加价幅度" prop="marginOfMarkup">
          <el-input v-model="editForm.marginOfMarkup" type="number"></el-input>
        </el-form-item>
        <el-form-item label="最低成交价" prop="minimumTransactionPrice">
          <el-input
            v-model="editForm.minimumTransactionPrice"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="拍卖数量" prop="auctionQuantity">
          <el-input v-model="editForm.auctionQuantity" type="number"></el-input>
        </el-form-item>

        <el-form-item label="拍卖结束时间" prop="auctionEndTime">
          <el-date-picker
            v-model="editForm.auctionEndTime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item>
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="选择商品"
      :visible.sync="visible"
      width="80%"
      append-to-body
      :before-close="handlClose"
    >
      <div style="padding-bottom: 40px">
        <el-table :data="userList" border stripe style="width: 100%">
          <el-table-column align="center" label="商品封面" min-width="120">
            <template slot-scope="scope"
              ><img :src="scope.row.cover" alt="" height="50px" width="50px" />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="商品名"
            min-width="120"
            prop="commodityName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="商品规格"
            min-width="120"
            prop="commoditSpecifications"
          ></el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            width="200"
            label="操作"
            prop="icon"
          >
            <template slot-scope="scope">
              <el-button plain type="success" @click="usersumbit(scope.row)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="usersearchForm.pageNo"
          :page-size="usersearchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="usr_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleUserSizeChange"
          @current-change="handleUserCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="出价记录"
      :visible.sync="auctionvisible"
      width="80%"
      append-to-body
      :before-close="handlClose"
    >
      <div style="padding-bottom: 40px">
        <el-table :data="auctionList" border stripe style="width: 100%">
          <el-table-column align="center" label="头像" min-width="120">
            <template slot-scope="scope"
              ><img
                :src="scope.row.avatarUrl"
                alt=""
                height="50px"
                width="50px"
              />
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="用户昵称"
            min-width="200"
            prop="nickName"
          ></el-table-column>
          <el-table-column
            align="center"
            label="出价"
            min-width="200"
            prop="auctionPrice"
          ></el-table-column>
          <el-table-column
            align="center"
            label="出价时间"
            min-width="200"
            prop="bidTime"
          >
            <template slot-scope="{ row }">
              {{ ForMat(row.bidTime, "yyyy-MM-dd HH:mm:dd") }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="auctionsearchForm.pageNo"
          :page-size="auctionsearchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="auction_total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleAuctionSizeChange"
          @current-change="handleAuctionCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VploadImgs from "../inc/VploadImgThree";
import area from "../stash/area.json";
export default {
  name: "ConfigType",
  components: {
    VploadImgs,
  },
  data() {
    return {
      auctionList: [],
      auctionvisible: false,
      type: 1,
      id: null,
      userList: [],
      area,
      props: { multiple: true, value: "name", label: "name", children: "area" },
      tableData: [],
      dialogVisible: false,
      auction_total: 0,
      filelist: [],
      editForm: {
        auctionDeposit: 0,
        auctionEndTime: "",
        auctionQuantity: 0,
        commoditId: 0,
        commoditSpecificationsId: 0,
        marginOfMarkup: 0,
        minimumTransactionPrice: 0,
        startingPrice: 0,
        commoditName: "",
      },
      total: 0,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
      },
      usr_total: 0,
      usersearchForm: {
        pageNo: 1,
        pageSize: 10,
        name: null,
        phone: null,
      },
      auctionsearchForm: {
        pageNo: 1,
        pageSize: 10,
        auctionGoodsId: "",
      },
      psarea: [],
      visible: false,
      rules: {
        auctionDeposit: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        auctionQuantity: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        marginOfMarkup: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        minimumTransactionPrice: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        startingPrice: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        auctionEndTime: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        commoditId: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    updState(event) {
      var _this = this;
      this.$confirm(
        event.state == 0
          ? "此操作将上架给拍卖, 是否继续?"
          : "此操作将下架该拍卖, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.$axios
            .post("/admin/auction-goods/updStatus", {
              id: event.auctionGoodsId,
            })
            .then((res) => {
              _this.getList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
    usersumbit(i) {
      this.editForm.commoditId = i.commodityId;
      this.editForm.commoditName =
        i.commodityName + " / " + i.commoditSpecifications;
      this.editForm.commoditSpecificationsId = i.commoditSpecificationsId;
      this.visible = false;
    },
    getuser() {
      this.$axios
        .get(
          "/admin/entrepotCommodity/getDispatchCommodityList?pageNo=" +
            this.usersearchForm.pageNo +
            "&pageSize=" +
            this.usersearchForm.pageSize,
          {},
        )
        .then((res) => {
          this.userList = res.data.records;
          this.usr_total = res.data.total;
        });
    },
    selectUser() {
      this.type = 1;
      this.usersearchForm = {
        pageNo: 1,
        pageSize: 10,
      };
      this.getuser();
      this.visible = true;
    },
    getStoreGoods() {
      this.usersearchForm.pageNo = 1;
      this.getuser();
    },
    handleUserSizeChange(val) {
      this.usersearchForm.pageSize = val;
      this.getuser();
    },
    handleUserCurrentChange(val) {
      this.usersearchForm.pageNo = val;
      this.getuser();
    },
    handleAuctionSizeChange(val) {
      this.auctionsearchForm.pageSize = val;
      this.getAuction();
    },
    handleAuctionCurrentChange(val) {
      this.auctionsearchForm.pageNo = val;
      this.getAuction();
    },
    seenum(row) {
      this.auctionsearchForm.auctionGoodsId = row.auctionGoodsId;
      this.auctionsearchForm.pageNo = 1;
      this.auctionvisible = true;
      this.getAuction();
    },
    getAuction() {
      this.$axios
        .post("/admin/auctionRecords/getList", this.auctionsearchForm)
        .then((res) => {
          this.auctionList = res.data.records;
          this.auction_total = res.data.total;
        });
    },
    getImg(i) {
      this.editForm.cover = i;
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    ForMat(date, fmt) {
      var date = new Date(date);
      let obj = {
        y: date.getFullYear(), // 年份，注意必须用getFullYear
        M: date.getMonth() + 1, // 月份，注意是从0-11
        d: date.getDate(), // 日期
        q: Math.floor((date.getMonth() + 3) / 3), // 季度
        H: date.getHours(), // 24小时制
        h: date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
        m: date.getMinutes(), // 分钟
        s: date.getSeconds(), // 秒
        S: date.getMilliseconds(), // 毫秒
      };
      for (let i in obj) {
        fmt = fmt.replace(new RegExp(i + "+", "g"), function (m) {
          let val = String(obj[i]);
          for (let j = 0, len = val.length; j < m.length - len; j++) {
            val = "0" + val;
          }
          return m.length === 1 ? val : val.substring(val.length - m.length);
        });
      }
      return fmt;
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.editForm));

          var ruleForm = {
            auctionDeposit: Number(obj.auctionDeposit),
            auctionEndTime: obj.auctionEndTime,
            auctionQuantity: Number(obj.auctionQuantity),
            commoditId: Number(obj.commoditId),
            commoditSpecificationsId: Number(obj.commoditSpecificationsId),
            marginOfMarkup: Number(obj.marginOfMarkup),
            minimumTransactionPrice: Number(obj.minimumTransactionPrice),
            startingPrice: Number(obj.startingPrice),
          };
          if (obj.auctionGoodsId) {
            ruleForm.auctionGoodsId = obj.auctionGoodsId;
            this.$axios
              .post("/admin/auction-goods/upd", ruleForm)
              .then((res) => {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("editForm");
                this.searchForm.pageNo = 1;
                this.getList();
              });
          } else {
            this.$axios
              .post("/admin/auction-goods/add", ruleForm)
              .then((res) => {
                this.$message({
                  showClose: true,
                  message: "恭喜你，操作成功",
                  type: "success",
                  onClose: () => {},
                });
                this.handleClose("editForm");
                this.searchForm.pageNo = 1;
                this.getList();
              });
          }
        }
      });
    },
    getList() {
      this.$axios
        .post("/admin/auction-goods/getList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    setsu() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.editForm = {
        auctionDeposit: "",
        auctionEndTime: "",
        auctionQuantity: "",
        commoditId: "",
        commoditSpecificationsId: "",
        marginOfMarkup: "",
        minimumTransactionPrice: "",
        startingPrice: "",
      };
      this.fileList = [];
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    handlClose() {
      this.visible = false;
      this.auctionvisible = false;
    },

    UpdateButton(row, type) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editForm.commoditName =
        this.editForm.name + " / " + this.editForm.commoditSpecifications;
      this.dialogVisible = true;
    },
    delHandle(id) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post("/admin/auction-goods/del", {
            id: id,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {},
            });
            this.getList();
          });
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}

.cus_area {
  margin: 10px;
}
</style>
